import { Flex, Text, Button, Group } from '@mantine/core';

import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';
import { useResponsive } from '@/shared';
import { withdrawalStatusTitle } from '../utils/const/common';
import { useWithdrawalStatus } from '../hooks/use-withdrawal-status';

import type { TWithdrawal } from '../store/types';

type Props = {
  item: TWithdrawal;
};

export const WithdrawalStatus = (props: Props) => {
  const { item } = props;
  const { isDesktop } = useResponsive();

  const {
    isApproveLoading,
    isDeclineLoading,
    isInPorgressLoaging,
    handleApproveWithdrawal,
    handleDeclineWithdrawal,
    handleInProgressWithdrawal,
    checkWithdrawal,
    isCheckLoading,
  } = useWithdrawalStatus();

  const isMexcPending = item.payoutSystem === 'mexc' && ['pending', 'submitted'].includes(item.payoutStatus || '');
  const isShowApproveAndDeclineBtns = !isMexcPending && (item.status === 'created' || item.status === 'in_progress');

  return (
    <Flex align={'flex-end'} direction={'column'}>
      <Text size={isDesktop ? 'sm' : 'xs'} ta="right">
        {withdrawalStatusTitle[item.status]}
        {' '}
        {item.updated && dayjsCustom(item.updated).format('DD.MM в HH:mm')}
      </Text>

      {item.payoutSystem === 'mexc' && item.payoutStatus && (
        <Text size="xs" ta="right">
          {item.payoutStatus === 'pending' && 'MEXC: результат выплаты уточняется'}
          {item.payoutStatus === 'submitted' && 'MEXC: выплата обрабатывается'}
          {item.payoutStatus === 'success' && 'MEXC: выплата завершена'}
          {['failed', 'rejected'].includes(item.payoutStatus) && 'MEXC: выплата не выполнена'}
        </Text>
      )}

      {isMexcPending && (
        <Button
          size="xs"
          loading={isCheckLoading}
          onClick={(e) => {
            e.stopPropagation();
            checkWithdrawal({ withdrawalId: item.id });
          }}
        >
          Проверить выплату
        </Button>
      )}

      {isShowApproveAndDeclineBtns && (
        <Group gap="xs" justify="flex-end">
          <Button
            variant="filled"
            size="xs"
            loading={isApproveLoading}
            onClick={(e) => {
              e.stopPropagation();
              handleApproveWithdrawal({ withdrawalId: item.id });
            }}
          >
            Подтвердить
          </Button>

          <Button
            variant="filled"
            color='red'
            size="xs"
            loading={isDeclineLoading}
            onClick={(e) => {
              e.stopPropagation();
              handleDeclineWithdrawal({ withdrawalId: item.id })
            }}
          >
            Отклонить
          </Button>

          {item.status === 'created' && (
            <Button
              variant="filled"
              color="teal"
              size="xs"
              loading={isInPorgressLoaging}
              onClick={(e) => {
                e.stopPropagation();
                handleInProgressWithdrawal({ withdrawalId: item.id })
              }}
            >
              В работу
            </Button>
          )}
        </Group>
      )}
    </Flex>
  );
};
